import React from 'react';

const StorefrontAppointmentHistoryPagination = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <nav className="sf-ah-pagination" aria-label="Pages">
      <button
        type="button"
        className="sf-ah-page-btn"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Previous
      </button>
      <span className="sf-ah-pagination__info">
        Page
        {' '}
        {page}
        {' '}
        of
        {' '}
        {totalPages}
      </span>
      <button
        type="button"
        className="sf-ah-page-btn"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </button>
    </nav>
  );
};

export default StorefrontAppointmentHistoryPagination;
